const _i18n=(()=>{try{const s=document.getElementById('il-i18n');return s?JSON.parse(s.textContent):{};}catch{return {};}})();
const t=(key,p={})=>{const v=_i18n[key]??key;return Object.entries(p).reduce((s,[k,val])=>s.replace('{'+k+'}',val),String(v));};
const mounted=new WeakSet();
function bootstrap(scope){
  scope.querySelectorAll('[data-collection-preview]').forEach(root=>{if(!mounted.has(root)){mounted.add(root);initialize(root);}});
}
bootstrap(document);
document.addEventListener('shopify:section:load',event=>bootstrap(event.target));

function initialize(root){
  const cards=[...root.querySelectorAll('[data-name-preview]')],input=root.querySelector('[data-collection-name]');
  if(!cards.length||!input)return;
  root.querySelector('[data-collection-personalise]').hidden=false;
  const status=root.querySelector('[data-collection-status]'),visible=new Set(),nearby=new Set(),inFlight=new Set(),cache=new Map();
  const original=new Map(cards.map(card=>[card,card.href]));
  let revision=0,timer,enginePromise,destroyed=false,activeName='';
  const lanes=Array.from({length:2},()=>({engine:null,busy:false}));
  const valid=name=>/^[A-Za-z]{1,12}$/.test(name);
  const saved=()=>{try{return sessionStorage.getItem('il-preview-name')||'';}catch{return '';}};
  const remembered=new URLSearchParams(location.search).get('preview_name')??saved();
  if(valid(remembered))input.value=remembered;
  function state(card,value,message){
    card.dataset.previewState=value;card.querySelector('[data-card-preview]').hidden=false;
    card.querySelector('[data-card-preview-image]').hidden=true;
    card.querySelector('[data-card-preview-notice]').hidden=false;
    card.querySelector('[data-card-preview-message]').textContent=message;
    card.setAttribute('aria-busy',String(value==='loading'));
  }
  function clearCard(card){
    delete card.dataset.previewState;card.querySelector('[data-card-preview]').hidden=true;
    card.querySelector('[data-card-preview-image]').removeAttribute('src');card.removeAttribute('aria-busy');card.href=original.get(card);
  }
  function show(card,item,name){
    const image=card.querySelector('[data-card-preview-image]');image.src=item.url;image.alt=`${name} — ${card.querySelector('.cname')?.textContent.trim()||'personalized preview'}`;
    image.hidden=false;card.dataset.previewState='ready';card.removeAttribute('aria-busy');
    // Foot choices are explained on the product page; cards only flag a preview that needs review.
    const notice=card.querySelector('[data-card-preview-notice]');notice.hidden=!item.review;
    card.querySelector('[data-card-preview-message]').textContent=item.review?t('collection.review_needed'):'';
  }
  function trimCache(){
    // Do not revoke URLs still used by displayed cards.
    const used=new Set(cards.map(card=>card.querySelector('[data-card-preview-image]').getAttribute('src')));
    for(const [key,item] of cache){if(cache.size<=32)break;if(!used.has(item.url)){URL.revokeObjectURL(item.url);cache.delete(key);}}
  }
  function park(card){
    // Offscreen images can release their decoded pixels. A cached Blob recreates the
    // thumbnail on return without keeping all 90 catalogue images mounted forever.
    if(card.dataset.previewState!=='ready')return;
    card.querySelector('[data-card-preview-image]').removeAttribute('src');
    state(card,'loading',t('collection.loading'));
  }
  function pump(){
    if(destroyed||!activeName||document.hidden)return;
    // Restore cached visible cards immediately, even while other cards are building.
    for(const card of cards){
      if(!visible.has(card)||card.dataset.previewState!=='loading')continue;
      const key=original.get(card)+'|'+activeName.toLowerCase();
      if(cache.has(key)){const item=cache.get(key);cache.delete(key);cache.set(key,item);show(card,item,activeName);}
    }
    for(const lane of lanes){
      if(lane.busy)continue;
      const waiting=c=>c.dataset.previewState==='loading'&&!inFlight.has(c);
      let card=cards.find(c=>visible.has(c)&&waiting(c));
      // Start the next row only after all visible cards are complete. Bound
      // prefetch to one lane so a scroll always has spare preparation capacity.
      if(!card&&!cards.some(c=>visible.has(c)&&c.dataset.previewState==='loading')&&!lanes.some(l=>l.busy))card=cards.find(c=>nearby.has(c)&&waiting(c)&&!cache.has(original.get(c)+'|'+activeName.toLowerCase()));
      if(card)renderCard(lane,card);
    }
  }
  async function renderCard(lane,card){
    lane.busy=true;inFlight.add(card);const run=revision,name=activeName,key=original.get(card)+'|'+name.toLowerCase();
    const current=()=>!destroyed&&run===revision&&(visible.has(card)||nearby.has(card));
    try{
      if(!enginePromise)enginePromise=import(root.dataset.thumbnailEngine).catch(error=>{enginePromise=null;throw error;});
      const {ThumbnailRenderer}=await enginePromise;
      if(!current())return;
      // Cards mix signs, keychains and magnets: one program for all of them, so a
      // page compiles once (per-type programs raced the card geometry for the CPU).
      if(!lane.engine)lane.engine=new ThumbnailRenderer({allFeatures:true});
      const result=await lane.engine.render(original.get(card),name,current,{displayWidth:card.querySelector('.thumb').clientWidth});
      if(!result||!current())return;
      if(result.tooShort){state(card,'invalid',t('collection.min_letters',{count:result.tooShort}));return;}
      const item={...result,url:URL.createObjectURL(result.blob)};delete item.blob;
      cache.set(key,item);if(visible.has(card))show(card,item,name);trimCache();
    }catch(error){if(!destroyed&&run===revision){state(card,'error',t('collection.error'));console.warn('Collection preview:',error.message);}}
    finally{lane.busy=false;inFlight.delete(card);if(destroyed)lane.engine?.dispose();else setTimeout(pump,0);}
  }
  function update(){
    revision++;clearTimeout(timer);
    for(const lane of lanes)if(lane.busy)lane.engine?.cancel();
    const name=input.value.trim();activeName='';
    const ok=valid(name);
    input.setAttribute('aria-invalid',String(!!name&&!ok));
    try{if(ok)sessionStorage.setItem('il-preview-name',name);else sessionStorage.removeItem('il-preview-name');}catch{}
    for(const card of cards){
      if(!name){clearCard(card);continue;}
      card.querySelector('[data-card-preview-image]').removeAttribute('src');
      const url=new URL(original.get(card));if(ok)url.searchParams.set('preview_name',name);card.href=url.href;
      state(card,ok?'loading':'invalid',ok?t('collection.loading'):t('collection.az_only'));
    }
    status.textContent=!name?t('collection.status_empty'):!ok?t('collection.status_invalid'):t('collection.status_showing',{name});
    if(ok)timer=setTimeout(()=>{activeName=name;pump();},350);
    trimCache();
  }
  const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting)visible.add(entry.target);else{visible.delete(entry.target);park(entry.target);}}trimCache();pump();},{rootMargin:'0px'});
  const prefetchObserver=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting)nearby.add(entry.target);else nearby.delete(entry.target);}pump();},{rootMargin:'250px 0px'});
  cards.forEach(card=>{observer.observe(card);prefetchObserver.observe(card);});
  input.addEventListener('input',update);
  const onVisibility=()=>{if(!document.hidden)pump();};
  const clear=root.querySelector('[data-collection-clear]');
  const onClear=()=>{input.value='';update();input.focus();};
  document.addEventListener('visibilitychange',onVisibility);
  clear.addEventListener('click',onClear);
  const dispose=()=>{if(destroyed)return;destroyed=true;revision++;clearTimeout(timer);observer.disconnect();prefetchObserver.disconnect();input.removeEventListener('input',update);clear.removeEventListener('click',onClear);document.removeEventListener('visibilitychange',onVisibility);window.removeEventListener('pagehide',onPageHide);document.removeEventListener('shopify:section:unload',onUnload);for(const lane of lanes)lane.engine?.dispose();for(const item of cache.values())URL.revokeObjectURL(item.url);cache.clear();};
  const onPageHide=event=>{if(!event.persisted)dispose();};
  const onUnload=event=>{if(event.target.contains(root))dispose();};
  window.addEventListener('pagehide',onPageHide);
  document.addEventListener('shopify:section:unload',onUnload);
  update();
  delete root.dataset.previewPending;
}
